module.exports = __webpack_public_path__ + "img/btn1.0790f49.png";